export default {
  branding: {
    title: "Visual identity",
    subtitle: "Customize your organization's logo and primary color.",
    errImageOnly: "Only images are allowed (PNG, JPG, WebP, SVG)",
    errTooBig: "The logo cannot exceed 2 MB",
    errUploadFailed: "Error uploading the logo",
    saved: "Changes saved successfully",
    logo: "Logo",
    logoHelp: "It will be shown in the sidebar instead of the HelixScan logo. PNG, JPG, WebP or SVG · Max. 2 MB · Recommended: transparent background, 4:1 ratio.",
    logoPreviewAlt: "Logo preview",
    dropLine1: "Drag or click",
    dropLine2: "to upload a logo",
    changeLogo: "Change logo",
    selectLogo: "Select logo",
    uploading: "Uploading…",
    saveLogo: "Save logo",
    removeLogo: "Remove logo",
    primaryColor: "Primary color",
    primaryColorHelp: "Affects the sidebar, buttons and accent elements across the entire interface.",
    customColor: "Custom color",
    preview: "Preview",
    primaryButton: "Primary button",
    activeElement: "Active element",
    saving: "Saving…",
    saveColor: "Save color",
    resetTitle: "Reset to default",
    resetHelp: "Revert to the standard HelixScan logo and color.",
    resetButton: "Reset to default",
  },
};
